export const LANDING_PAGE = "/"
export const HOME = "/dashboard"
export const LOGIN = "/login"
export const REGISTER = "/register"
export const BOARDS = "/boards"
export const SCHEDULE = "schedule"
export const CALENDAR = "calendar"
export const SUMMARY = "summary"
export const BACKLOG = "backlog"
export const TABLE = `table`
export const BOARD_ID = ":boardId"
export const TICKETS = "/tickets"
export const TICKET_ID = ":ticketId"
export const SPRINTS = "sprints"
export const SPRINT_ID = ":sprintId"
export const USERS = "/users"
export const USER = "/user"
export const PROJECTS = "/projects"
export const ORGANIZATION = "/organization"
export const FORGOT_PASSWORD = "/forgot-password"
export const RESET_PASSWORD = "/reset-password"
export const ACTIVATION = "/activate"
export const ACCOUNT = "/account"
export const TEMP = "/temp"
export const REGISTER_USER = `${REGISTER}${USER}`
export const REGISTER_ORG = `${REGISTER}/${ORGANIZATION}`
export const ORGANIZATION_ADD_EDIT_STATUSES = `${ORGANIZATION}/add-edit-status`
export const ACCOUNT_CREATE_ORG = `${ACCOUNT}${ORGANIZATION}`
export const ACCOUNT_CHANGE_PASSWORD = `${ACCOUNT}/change-password`
export const ACCOUNT_JOIN_ORGANIZATION = `${ACCOUNT}/join-organization`
export const ACCOUNT_SWITCH_ORGANIZATION = `${ACCOUNT}/switch-organization`
export const ACCOUNT_NOTIFICATION_SETTINGS = `${ACCOUNT}/notification-settings`
export const ACCOUNT_REGISTRATION_REQUESTS = `${ACCOUNT}/registration-requests`
export const NOTIFICATIONS = "/notifications"
